import { TOOL_ENGINE_LABELS, superGroupOf, superGroupLabel, sortToolEngines } from "./format";
import { toolEngineValue, unionSessionCount } from "./timeseries";

// "도구별 사용량" 차트/표가 실제로 그릴 항목 목록을 만든다. 접힌 슈퍼그룹은 항목 1개(그
// 그룹에서 선택된 엔진들의 합계), 펼친 슈퍼그룹은 선택된 엔진마다 항목 1개 — 기본값(전부
// 접힘)이면 라인/컬럼이 10개를 안 넘어서 한눈에 들어오고, 특정 그룹만 펼치면 그 안의
// 엔진별 디테일까지 보인다(2026-07-16, "차트가 스파게티" 피드백 대응).
export function buildDisplayItems(selected, expandedGroups, groupOrder) {
  const bySuperGroup = new Map();
  for (const e of selected || []) {
    const sg = superGroupOf(e.tool);
    if (!bySuperGroup.has(sg)) bySuperGroup.set(sg, []);
    bySuperGroup.get(sg).push(e);
  }

  const items = [];
  for (const sg of groupOrder) {
    const engines = bySuperGroup.get(sg);
    if (!engines || engines.length === 0) continue; // 그룹 전체 해제됨 — 스킵

    if (expandedGroups.has(sg)) {
      for (const e of sortToolEngines(engines)) {
        const key = `${e.tool}|${e.engine}`;
        items.push({ kind: "engine", id: key, superGroup: sg, keys: [key], label: TOOL_ENGINE_LABELS[key] || e.engine });
      }
    } else {
      items.push({
        kind: "group",
        id: sg,
        superGroup: sg,
        keys: engines.map((e) => `${e.tool}|${e.engine}`),
        label: superGroupLabel(sg),
      });
    }
  }
  return items;
}

// 항목 하나(그룹 합계 또는 개별 엔진) 값 — 세션 수는 그 항목에 속한 키들의 합집합.
export function itemValue(row, item, unit) {
  if (unit === "sessions") return unionSessionCount([row], item.keys);
  return item.keys.reduce((s, k) => s + toolEngineValue(row, k, unit), 0);
}

// 여러 기간(rows)에 걸친 항목 하나의 합계 — 세션 수는 그 기간 전체 + 그 항목 키들의 합집합.
export function itemTotal(rows, item, unit) {
  if (unit === "sessions") return unionSessionCount(rows, item.keys);
  return rows.reduce((s, r) => s + itemValue(r, item, unit), 0);
}

// 전체 항목·전체 기간 총합(표 우하단 grand total) — 세션 수는 전 항목 키 합쳐서 합집합.
export function grandTotal(rows, items, unit) {
  if (unit === "sessions") return unionSessionCount(rows, items.flatMap((i) => i.keys));
  return items.reduce((s, item) => s + itemTotal(rows, item, unit), 0);
}
